// eslint-disable-next-line import/prefer-default-export
export function parseFreeSoloText(text: string) {
  if (text.startsWith("Add ")) {
    return text.slice(5, -1);
  }
  return text;
}

export function generateOptionKey() {
  return Math.random().toString(36).substring(2, 15);
}
